import { TtsClientAdapter, TtsClientResult } from './tts-adapter.interface';

export class WebSpeechTtsAdapter implements TtsClientAdapter {
  private utterance: SpeechSynthesisUtterance | null = null;

  isLocal(): boolean {
    return true;
  }

  isSupported(): boolean {
    return 'speechSynthesis' in window;
  }

  speak(text: string): Promise<TtsClientResult> {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      this.utterance = new SpeechSynthesisUtterance(text);
      this.utterance.lang = 'ru-RU';

      this.utterance.onend = () => {
        resolve({ processingTimeMs: Date.now() - start, isLocal: true });
      };

      this.utterance.onerror = (e) => {
        reject(new Error(`Browser TTS error: ${e.error}`));
      };

      window.speechSynthesis.speak(this.utterance);
    });
  }

  stop(): void {
    window.speechSynthesis.cancel();
  }
}
